import StatusBadge from "../components/StatusBadge";

function MatchPage({
  title = "Matches",
  description = "",
  createActionNode = null,
  metricsNode = null,
  showcaseNode = null,
  gateNode = null,
  sidebarNode = null,
  mainNode = null,
  selectedMatch = null,
  children = null,
}) {
  const hasStructuredLayout = Boolean(sidebarNode || mainNode);

  return (
    <section id="play" className="appRoutePage matchRoutePage productSection">
      <div className="routePageHeader matchPageHeader">
        <div className="matchPageHero">
          <div className="matchPageHeroCopy">
            <span className="leaguePageEyebrow">{title}</span>
            <h1>{selectedMatch ? `${selectedMatch.team_a_name} vs ${selectedMatch.team_b_name}` : title}</h1>
            <p>
              {selectedMatch
                ? `${selectedMatch.platform} | ${selectedMatch.time_control} | ${selectedMatch.rated ? "rated" : "casual"}`
                : description}
            </p>
            {selectedMatch ? (
              <div className="matchPageHeroMeta">
                <StatusBadge status={selectedMatch.status} />
                <span>{selectedMatch.match_duration_days} day window</span>
                <span>{selectedMatch.boards?.length || 0} boards</span>
              </div>
            ) : null}
          </div>
          {selectedMatch ? (
            <div className="matchPageScoreHero">
              <div className="matchPageTeamScore">
                <strong>{selectedMatch.team_a_name}</strong>
                <span>{selectedMatch.team_a_score}</span>
              </div>
              <div className="matchPageScoreDivider">VS</div>
              <div className="matchPageTeamScore">
                <strong>{selectedMatch.team_b_name}</strong>
                <span>{selectedMatch.team_b_score}</span>
              </div>
            </div>
          ) : null}
        </div>
        {createActionNode}
      </div>
      {metricsNode}
      {showcaseNode}
      {gateNode}
      {hasStructuredLayout ? (
        <div className="matchRouteShell">
          <aside className="matchRouteSidebar">{sidebarNode}</aside>
          <div className="matchRouteStage">{mainNode}</div>
        </div>
      ) : children ? (
        <div className="matchRouteLegacy">{children}</div>
      ) : (
        <div className="matchRouteShell">
          <div className="matchRouteStage" />
        </div>
      )}
    </section>
  );
}

export default MatchPage;
